import styled from 'styled-components';
import { Check } from 'lucide-react';

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: ${props => props.spacing || '6px'};
  position: relative;
`;

const TwitterVerifiedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size || '16px'};
  height: ${props => props.size || '16px'};
  min-width: ${props => props.size || '16px'};
  min-height: ${props => props.size || '16px'};
  background: #1d9bf0;
  border-radius: 50%;
  cursor: ${props => props.tooltip ? 'help' : 'default'};
  
  svg {
    color: white;
    width: ${props => `calc(${props.size || '16px'} * 0.6)`};
    height: ${props => `calc(${props.size || '16px'} * 0.6)`};
    stroke-width: 3;
  }
`;

const VerificationBadge = ({ 
  isVerified, 
  size = '16px', 
  spacing = '6px',
  tooltip = 'Verified',
  className 
}) => {
  if (!isVerified) return null;

  return (
    <Badge 
      spacing={spacing}
      className={className}
      title={tooltip}
    >
      <TwitterVerifiedBadge 
        size={size}
        tooltip={tooltip}
      >
        <Check />
      </TwitterVerifiedBadge>
    </Badge>
  );
};

export default VerificationBadge;